import type { BiometricState } from './types.ts';

// Human name for whatever the device offers, so the button says "Face ID"
// rather than "biometrics".
export const biometricLabel = (type: BiometricState['type']): string => {
  if (type === 'face') return 'face';
  if (type === 'finger') return 'fingerprint';
  return 'biometrics';
};
